import { Component, Fragment } from "react";
import { Button, Form, InputGroup, Stack } from "react-bootstrap";

const questionType = Object.freeze({
    TextResponse: 0,
    MultipleChoice: 1,
    MultipleSelect: 2,
  });

export class TemplateItem extends Component {
    constructor(props) {
        super(props)
        if (props.viewOnlyMode || props.templateItemData) {
            this.state = {...props.templateItemData}
        } else {
            this.state = {
                question: '',
                questionType: 0,
                answerSet: [''],
            }
        }
    }

    addToAnswerSet (){
        this.setState({
            answerSet: [...this.state.answerSet, ''],
        })
    }

    handleQuestionChange = field => (e) => {
        if (field === 'questionType') {
            this.setState({[field]: parseInt(e.target.value)})
        } else {
            this.setState({[field]: e.target.value})
        }
        
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState !== this.state) {
            this.props.handleChange(this.props.questionIdx, {...this.state})
        }
    }

    handleAnswerOptionsChange = idx => (e) => {
        const newOptions = [...this.state.answerSet]
        newOptions[idx] = e.target.value
        this.setState({
            answerSet: newOptions,
        })
    }
    handleOptionDelete = (idx) => {
        const optionsCopy = [...this.state.answerSet]
        optionsCopy.splice(idx, 1)
        this.setState({
            answerSet: optionsCopy
        })
    }

    render() {
        return (
            <Form className="mb-4">
                <Form.Group className="mb-3" controlId="ControlInput1">
                    <Stack className="justify-content-between mb-1" direction="horizontal">
                        <Form.Label>Question {this.props.questionIdx + 1}</Form.Label>
                        {this.props.numQuestions > 1 && !this.props.viewOnlyMode &&
                            <Button onClick={this.props.handleQuestionDelete} size="sm" variant="outline-danger" type="button"><i class="bi bi-trash"></i></Button>
                        }
                    </Stack>
                    <Form.Control readOnly={!!this.props.viewOnlyMode} value={this.state.question} onChange={this.handleQuestionChange('question')} placeholder="Enter question here..." type="text" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="ControlInput2">
                    <Form.Select disabled={!!this.props.viewOnlyMode} value={String(this.state.questionType)} onChange={this.handleQuestionChange('questionType')}>
                        <option value="0">Text Response</option>
                        <option value="1">Multiple Choice</option>
                        <option value="2">Multiple Select</option>
                    </Form.Select>
                </Form.Group>
                {this.state.questionType > 0 &&
                <Form.Group>
                        {this.state.answerSet.map((item, idx) => {
                            return <Fragment key={idx}>
                                <InputGroup>
                                    <Form.Control
                                        readOnly={!!this.props.viewOnlyMode}
                                        onChange={this.handleAnswerOptionsChange(idx)}
                                        value={this.state.answerSet[idx]}
                                        type="text" placeholder={`Option ${idx + 1}`} />
                                    {this.state.answerSet.length > 1 && !this.props.viewOnlyMode &&
                                        <Button onClick={() => this.handleOptionDelete(idx)} variant="outline-danger"><i class="bi bi-trash"></i></Button>
                                    }
                                </InputGroup>
                                <br />
                            </Fragment>
                        })}
                        {!this.props.viewOnlyMode &&
                            <Button className="mb-3" type="button" disabled={!this.state.answerSet[this.state.answerSet.length - 1]} variant="secondary" onClick={() => this.addToAnswerSet()}>Add option</Button>
                        }
                </Form.Group>
                }
            </Form>
        )
    }
}